<template>
	<div class="h-full">
		<div class="flex items-center h-full">
			<div class="w-full grid justify-items-center">
				<panel :title="$t('eny.welcome')" addclass='min-w-800 max-w-[1300px] my-3'>
					<div class="grid justify-items-center p-10">
						<p class="font-bold text-lg">{{$t('eny.confirmation')}}</p>
						<p class="text-base mt-5">{{$t('eny.next_step')}}</p>
					</div>
				</panel>
			</div>
		</div>
	</div>
</template>
<script>
import Panel from "../Base/Panel.vue";
import useNotification from "../hooks/useNotification";
import { mapGetters } from 'vuex';
export default {
	name: "UserRegisterConfirmation",
	components: {
		'panel': Panel,
	},
	setup() {
			const {showNotification} = useNotification();
			return {
					showNotification,
			}
	},
	methods: {
	},
	computed :{
		...mapGetters('user', ['loading', 'success', 'message']),
	},
	watch: {
		message(value) {
			if (value!=='') {
				this.showNotification(value, this.success ? 'info ': 'error', 5);
			}
		}
	}
}
</script>
